import { useEffect, useState } from 'react';
import api from '../lib/api';
import { fmtDate } from '../lib/utils';

const STATUS_STYLES = {
  active: 'bg-emerald-100 text-emerald-700',
  archived: 'bg-slate-100 text-slate-600',
  draft: 'bg-amber-100 text-amber-700',
};

export default function AssetTrackerPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/resources').then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="asset-tracker">
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50">
                {['Resource', 'Category', 'Owner', 'Status', 'Priority', 'Review Freq.', 'Last Updated', 'Next Review', 'Version'].map((h) => (
                  <th key={h} className="text-left text-xs font-heading uppercase tracking-wider text-slate-500 px-4 py-3">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`asset-${r.id}`}>
                  <td className="px-4 py-3">
                    <div className="font-semibold text-sm text-navy">{r.name}</div>
                    <div className="text-xs text-slate-500 line-clamp-1">{r.description || '—'}</div>
                  </td>
                  <td className="px-4 py-3 text-xs">{r.category}</td>
                  <td className="px-4 py-3 text-xs">{r.owner || '—'}</td>
                  <td className="px-4 py-3"><span className={`text-[10px] px-2 py-1 rounded-full font-semibold ${STATUS_STYLES[r.status]}`}>{r.status}</span></td>
                  <td className="px-4 py-3 text-xs capitalize">{r.priority}</td>
                  <td className="px-4 py-3 text-xs capitalize">{r.review_frequency || '—'}</td>
                  <td className="px-4 py-3 text-xs">{fmtDate(r.updated_at)}</td>
                  <td className="px-4 py-3 text-xs">{fmtDate(r.next_review_date)}</td>
                  <td className="px-4 py-3 text-xs font-semibold">v{r.version}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
